import { MiniRouter } from '@yimoka/mini-router';
import { observer } from '@yimoka/react';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { TriangleAlert } from 'lucide-react';
import { useEffect } from 'react';
import { Toaster } from 'sonner';

import { LocalizedFavicon } from '@/components/localized-favicon';
import { InitConfig } from '@/config';
import { I18nRoot } from '@/locales/i18n';
import { useLanguage } from '@/root';
import { RootRouter } from '@/router';

dayjs.locale('zh-cn');
dayjs.extend(duration);
dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);

const isEn = (lang: string) => lang?.includes('en');

/** 应用根组件负责初始化路由、运行时配置、多语言与全局提示。 */
export const App = observer(() => {
  const lang = useLanguage();
  useEffect(() => {
    if (isEn(lang)) {
      dayjs.locale('en');
    } else {
      dayjs.locale('zh-cn');
    }
  }, [lang]);
  return (
    <MiniRouter>
      <InitConfig>
        <I18nRoot>
          <LocalizedFavicon />
          <RootRouter />
          <Toaster
            duration={2200}
            icons={{
              warning: <TriangleAlert className="h-4 w-4 text-orange-500" />,
            }}
            position="top-center"
            toastOptions={{
              classNames: {
                toast: 'justify-center',
                content: 'items-center',
                title: 'text-center',
                icon: 'm-0',
              },
              style: {
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                color: '#111827',
                borderRadius: '6px',
                width: '150px',
                textAlign: 'center',
                height: '30px',
              },
            }}
          />
        </I18nRoot>
      </InitConfig>
    </MiniRouter>
  );
});
